import type { MediaAsset } from '@ghostscreen/contracts';
import { ContentLibraryTile } from './ContentLibraryTile';

type ContentLibraryGridProps = {
  assets: MediaAsset[];
  tileSize: number;
  usedMediaIds: ReadonlySet<string>;
  onOpen: (asset: MediaAsset) => void;
};

export function ContentLibraryGrid({
  assets,
  tileSize,
  usedMediaIds,
  onOpen,
}: ContentLibraryGridProps) {
  return (
    <div
      className="grid gap-1"
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${tileSize}px), 1fr))`,
      }}
    >
      {assets.map((asset) => (
        <ContentLibraryTile
          key={asset.id}
          asset={asset}
          unused={!usedMediaIds.has(asset.id)}
          onOpen={onOpen}
        />
      ))}
    </div>
  );
}
